import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
// import colors from 'vuetify/lib/util/colors';
import es from 'vuetify/lib/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#da4726",
        // secondary: colors.lightGreen.darken1,
        // accent: colors.shades.black,
        // error: colors.red.darken3,
      },
      dark: {
        primary: "#da4726",
      },
    },
  },
    lang: {
      locales: { es },
      current: 'es',
    },
});
